import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLang } from "@/context/LanguageContext";

export function HowItWorks() {
  const { L } = useLang();
  const nums = ["01", "02", "03"];
  return (
    <section id="how-it-works" className="scroll-mt-24 bg-canvas py-20 lg:py-28">
      <div className="container-tight">
        <div className="max-w-2xl">
          <p className="overline mb-3">{L.how.overline}</p>
          <h2 className="font-heading text-3xl lg:text-4xl font-semibold tracking-tight text-ink">{L.how.title}</h2>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {L.how.steps.map((s, i) => (
            <div key={i} className="relative rounded-xl border border-hair bg-white p-8 shadow-sm" data-testid={`how-step-${nums[i]}`}>
              <span className="font-heading text-5xl font-bold text-hair">{nums[i]}</span>
              <div className="absolute end-8 top-8 h-2 w-2 rounded-full bg-gold" />
              <h3 className="mt-4 font-heading text-xl font-semibold text-ink">{s[0]}</h3>
              <p className="mt-2 text-sm leading-relaxed text-subtle">{s[1]}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-start gap-6 rounded-xl border border-hair bg-white p-6 lg:flex-row lg:items-center lg:justify-between">
          <p className="text-sm leading-relaxed text-subtle">
            <span className="font-semibold text-ink">{L.how.noteLabel} </span>{L.how.note}
          </p>
          <Button asChild className="shrink-0 bg-finblue hover:bg-finblueDark" data-testid="how-get-started">
            <Link to="/broker-partners">{L.common.getStarted}</Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
